import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { configModel } from 'src/models/config.model';
import { ConfigService } from 'src/services/config.service';

@Component({
  selector: 'app-participant-footer',
  templateUrl: './participant-footer.component.html',
  styleUrls: ['./participant-footer.component.css'],
  standalone: true,
  imports: [ParticipantFooterComponent,CommonModule]
})
export class ParticipantFooterComponent implements OnInit {
  configModel: configModel;
  hcontact: string;
  contactUsUrl: string = '';
  isUnauthorizedUserPage: boolean = false;

  constructor(private configService: ConfigService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {
        Promise.resolve().then(() => {
        let configModel = this.configService.getConfigModel();
        this.hcontact = configModel.getConfigkeyname('Header_Contact');
        this.cdr.markForCheck();
        });
      }
    });    
    this.isUnauthorizedUserPage = window.location.href.includes('unauthorized-user');
  }

  openContactUs() {
    this.configService.getContactUsUrl().subscribe(url => {
      if (url) {
        window.open(url, '_blank','noopener,noreferrer');
      }
    });
  }
}
